import type { ApiModuleEndpoints } from '../types'

export const billiardLightApiEndpoints = {
  list: { method: 'GET', path: '/billiard-light-devices', requiresAuth: true },
  create: { method: 'POST', path: '/billiard-light-devices', requiresAuth: true },
  update: { method: 'PUT', path: '/billiard-light-devices/:id', requiresAuth: true },
  delete: { method: 'DELETE', path: '/billiard-light-devices/:id', requiresAuth: true },
  states: { method: 'GET', path: '/billiard-lights/states', requiresAuth: true },
  command: { method: 'POST', path: '/sales-tables/:id/light/:action', requiresAuth: true },
  configure: { method: 'PUT', path: '/sales-tables/:id/light-device', requiresAuth: true },
  logs: { method: 'GET', path: '/sales-tables/:id/light-logs', requiresAuth: true },
} as const satisfies ApiModuleEndpoints
